<template>
  <div class="container my-4 my-md-10 py-4">
    <h2>Omschrijving</h2>
    <p v-html="car.mappeddata.description.substring(0, 300) + '...'"></p>
    <button type="button" class="btn mt-4" data-bs-toggle="modal" data-bs-target="#carInfoModal" @click="$emit('setActiveTab', 'carInfo-tab-3')">Verder lezen</button>
  </div></template>
<script>
export default {
  props: ['car'],
}
</script>
<style lang="scss" scoped>
.crc-car-component-container {
  .crc-single-car-hero .col-inner {
    border-radius: 4px;
    background-color: white;
  }

  .crc-imgslider {
    .crc-img-container {
      height: 700px;
    }
  }

  .crc-imgslider-nav {
    .crc-img-container {
      height: 100px;
      width: 14%;
    }
  }

  .crc-buttons {
    margin: 0 -6px;
    display: flex;
    flex-wrap: wrap;

    .btn {
      width: calc(100% - 12px);
      margin: 6px;

      &.half {
        width: calc(50% - 12px);
      }
    }
  }

  .crc-side-imgbg {
    background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 35%, rgba(0,0,0,.7) 100%);
    background-color: lightgrey;
    border-radius: 4px;
  }

  .crc-reffer-cards {
    .crc-reffer-card-img-head {
      position: relative;

      .crc-img-container {
        height: 200px;

        &.person {
          position: absolute;
          bottom: -20px;
          left: 48px;
          width: 100px;
          height: 100px;
          border-radius: 100px;
        }
      }
    }

    .crc-reffer-card-body {
      background-color: white;

      a.btn {
        width: 100%;
      }
    }
  }
}
</style>
